import { render, staticRenderFns } from "./btnTitle.vue?vue&type=template&id=089e55e6&"
import script from "./btnTitle.vue?vue&type=script&lang=js&"
export * from "./btnTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports